import { CircularProgress, Grid, Typography } from '@mui/material'
import ProjectCard from '../components/ProjectCard'
import PageShell from '../components/PageShell'
import WoodworkLogo from './WoodworkLogo'
import './WoodworkLogo.css'
import {
  projectCardDescription,
  useWoodworkProjects,
  woodworkProjectPath
} from '../api-hooks/useWoodworkProjects'
import { formatProjectDateRange } from '../content/formatProjectDate'

const Work = () => {
  const { projects, statusLabel, isLoading } = useWoodworkProjects()

  return (
    <PageShell className='page work-page'>
      <div className='work-page-brand'>
        <WoodworkLogo variant='branch' size='section' aria-hidden />
      </div>
      <p className='section-eyebrow'>Portfolio</p>
      <h1 className='section-heading'>Woodworking</h1>
      <Typography className='section-lead' component='p'>
        Furniture, shop projects, and casework.
      </Typography>
      {isLoading && projects.length === 0 ? (
        <CircularProgress size={28} sx={{ color: 'primary.main' }} />
      ) : (
        <Grid container spacing={3}>
          {projects.map((project) => (
            <Grid item xs={12} sm={6} md={4} key={project.id}>
              <ProjectCard
                title={project.title}
                description={projectCardDescription(project)}
                materials={project.materials}
                status={statusLabel[project.status]}
                date={formatProjectDateRange(project.startDate, project.endDate)}
                imageSrc={project.imageSrc}
                imageAlt={project.imageAlt}
                to={project.hasGallery ? woodworkProjectPath(project.id) : undefined}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </PageShell>
  )
}

export default Work
